
import Cookies from 'universal-cookie';

// A wrapper for universal-cookie

class CookieWrap {

  constructor() {
    this.cookies = new Cookies();
  }

  remove = (name, options=null) => {
    this.cookies.remove(name, options);
  };

  set = (name, value, options=null) => {
    this.cookies.set(name, value, options);
  };

  get = (name, options={}) => {
    return this.cookies.get(name, options);
  }
}

export { CookieWrap };
